<template>
  <li class="hot_list_wrap pnt" @click="goDetail(item.id, type)">
    <div class="hot_list_top" :class="{ on: botView }">
      <div class="list_con">
        <div class="list_txt_1">
          <span v-if="type == 'knowhow'">{{ isCategory(item.category) }}</span>
          {{ item.title }}
        </div>
        <div class="list_txt_2">
          {{ item.contents }}
        </div>
      </div>
      <div class="list_img" v-if="item.imagePath">
        <img :src="item.imagePath" alt="" />
      </div>
    </div>
    <div class="hot_list_bot" v-if="botView">
      <div class="list_txt_1">{{ item.createdAt | moment('from') }}</div>
      <div class="list_txt_2">
        <div class="txt">
          <div class="txt_img">
            <i class="i_list_like"></i>
          </div>
          <div class="txt_count">{{ item.likeCnt }}</div>
        </div>
        <div class="txt">
          <div class="txt_img">
            <i class="i_list_eye"></i>
          </div>
          <div class="txt_count">{{ item.readCnt }}</div>
        </div>
        <div class="txt">
          <div class="txt_img">
            <i class="i_list_reply"></i>
          </div>
          <div class="txt_count">{{ item.replyCnt }}</div>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
export default {
  name: 'community-hot-issue-list',
  props: {
    botView: Boolean,
    item: Object,
    type: String,
  },
  computed: {},
  methods: {
    isCategory(category) {
      // (MOBILE : 휴대폰, INTERNEST : 인터넷, MVNO : 알뜰폰, PLAN : 요금제, RENTAL : 렌탈, STORE : 매장)
      let cate = '';
      switch (category) {
        case 'MOBILE':
          cate = '휴대폰';
          break;
        case 'INTERNET':
          cate = '인터넷';
          break;
        case 'MVNO':
          cate = '알뜰폰';
          break;
        case 'PLAN':
          cate = '요금제';
          break;
        case 'RENTAL':
          cate = '렌탈';
          break;
        case 'STORE':
          cate = '매장';
          break;
      }

      return cate;
    },
    goDetail(boardId, type) {
      if (type == 'knowhow') {
        this.$router.push({
          name: 'Knowhow.Detail',
          params: { id: boardId, isRead: 'Y' },
          hash: '#',
        });
      } else {
        this.$router.push({
          name: 'Board.Detail',
          params: { id: boardId, isRead: 'Y' },
          hash: '#',
        });
      }
    },
  },
};
</script>
